export default "__VITE_ASSET__BYInv4cR__"